import React from 'react';

function Icon(props) {
  if (props.size == 'sm') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill={props.fill || '#1D252D'} viewBox="0 -960 960 960">
        <path d="M180.31-212q-27.01 0-45.66-18.66T116-276.35v-407.62q0-27.03 18.65-45.53t45.66-18.5h599.38q27.01 0 45.66 18.66T844-683.65v407.62q0 27.03-18.65 45.53T779.69-212zM480-449.69 168-633.31v357q0 5.39 3.46 8.85t8.85 3.46h599.38q5.39 0 8.85-3.46t3.46-8.85v-357zm0-67.31 305.85-179h-611.7zM168-633.31V-696v419.69q0 5.39 3.46 8.85t8.85 3.46H168z"></path>
      </svg>
    );
  }
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M172.309-180.001q-30.308 0-51.308-21t-21-51.308v-455.382q0-30.308 21-51.308t51.308-21h615.382q30.308 0 51.308 21t21 51.308v455.382q0 30.308-21 51.308t-51.308 21H172.309zM480-457.694L160-662.309v410q0 5.385 3.462 8.847 3.462 3.462 8.847 3.462h615.382q5.385 0 8.847-3.462 3.462-3.462 3.462-8.847v-410L480-457.694zM480-520l313.846-200H166.154L480-520zM160-662.309V-720v467.691q0 5.385 3.462 8.847 3.462 3.462 8.847 3.462H160v-422.309z"
      ></path>
    </svg>
  );
}

export default Icon;
